import useScreenSize from "../hooks/useScreenSize";

export default function ReviewsHero() {
  const { isMobile, isTablet } = useScreenSize();

  return (
    <section
      style={{
        position: "relative",
        minHeight: isMobile ? "65vh" : "80vh",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "120px 20px 40px" : "140px 48px 48px",
        color: "#F5F2EB",
      }}
    >
      <img
        src="/assets/about.png"
        alt="Ebenezer Exterior"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.55))",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          maxWidth: 900,
        }}
      >
        <p
          style={{
            color: "#E8C98B",
            letterSpacing: ".18em",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: isMobile ? 12 : 14,
            marginBottom: 20,
          }}
        >
          REVIEWS & LOCATION
        </p>

        <h1
          style={{
            color: "#FFF",
            fontFamily: "'Fraunces', serif",
            fontSize: isMobile ? 38 : isTablet ? 52 : 72,
            lineHeight: 1.1,
            fontWeight: 400,
            marginBottom: 24,
          }}
        >
          Trusted by travellers.
          <br />
          Perfectly placed in Kothanur.
        </h1>

        <p
          style={{
            color: "rgba(255,255,255,.82)",
            fontSize: isMobile ? 16 : 20,
            lineHeight: 1.8,
            maxWidth: isTablet ? 650 : 760,
            margin: "0 auto",
          }}
        >
          Discover why guests choose Ebenezer Serviced Apartments &
          Suites for business travel, family stays and extended visits
          to Bengaluru.
        </p>

        <div
          style={{
            marginTop: isMobile ? 35 : 60,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            style={{
              fontSize: isMobile ? 22 : 28,
              color: "#C9A66B",
              letterSpacing: 4,
            }}
          >
            ★★★★★
          </span>

          <span
            style={{
              color: "#FFF",
              fontSize: isMobile ? 15 : 18,
            }}
          >
            4.9 / 5 Guest Rating
          </span>
        </div>
      </div>
    </section>
  );
}